import { computeCell } from '../data/compute/compute-cell/index.js'
import { rowStyleClasses } from './row-style-classes.js'
import { makeTargetChartOfAccountIds } from './statement-layout/make-target-chart-of-accounts-ids.js'

export function debugOnCellClicked (cellParams, debugOptions) {
  console.log('debugOnCellClicked', cellParams)

  cellParams.context.showDebug = true
  const computed = computeCell(cellParams)
  console.log('computed', computed)

  showRowStyleClasses(cellParams, debugOptions)

  showCellDetails(cellParams, debugOptions)

  cellParams.context.showDebug = false
}

function showRowStyleClasses (cellParams, debugOptions) {
  if (!debugOptions?.showRowStyleClasses) return

  rowStyleClasses(cellParams)
}

function showCellDetails (cellParams, debugOptions) {
  if (!debugOptions?.showCellDetails) return

  console.log('... Cell:')
  const accountingOrganisationId = cellParams.colDef.context?.accountingOrganisation?.id
  console.log('accountingOrganisationId', accountingOrganisationId)

  const targetCurrencyCode = cellParams.context.currencySymbol === 'XXX' ? cellParams.colDef.context?.accountingOrganisation?.base_currency : cellParams.context.currencySymbol
  console.log('targetCurrencyCode', targetCurrencyCode)

  const monthDate = cellParams.colDef.context.monthDate
  console.log('monthDate', monthDate)

  const accountingChartOfAccountId = cellParams.data.accounting_chart_of_account_id
  console.log('accountingChartOfAccountId', accountingChartOfAccountId)

  const targetIds = makeTargetChartOfAccountIds(cellParams)
  console.log('targetIds', targetIds)
}
